// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mounted as a child inside pipeline-sandbox's own view container (a flex
   column) — fill it, rather than rendering our own fixed-position overlay.
   Layout otherwise borrows from pipeline-sandbox.css (.ps-detail-header,
   .ps-body, .btn, .ps-input, etc.) — this file adds the pieces shared by
   ml-models.js and ml-labeling.js (the .mlw-* classes) that aren't covered
   there. Originally the ML detector wizard's own stylesheet; the wizard was
   removed (sandbox-refocus-view-tune.md), this file survived as the two
   remaining consumers' shared styles — renamed accordingly. */
:host {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.mlw-resume-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
    background: var(--warning-bg, #fff8e1);
    color: var(--warning-fg, #7a5c00);
    border-bottom: 1px solid var(--border-color, #e0e0e0);
    font-size: 12px;
}

.mlw-resume-banner.hidden { display: none; }

.mlw-layout {
    flex: 1;
    display: flex;
    overflow: hidden;
}

.mlw-rail {
    width: 220px;
    flex-shrink: 0;
    border-right: 1px solid var(--border-color, #e0e0e0);
    padding: 12px 0;
    overflow-y: auto;
}

.mlw-rail-step {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 16px;
    cursor: pointer;
    font-size: 12px;
    color: var(--text-secondary, #666);
    border-left: 3px solid transparent;
}

.mlw-rail-step:hover {
    background: var(--bg-hover, #f5f5f5);
}

.mlw-rail-step.active {
    border-left-color: var(--accent-color, #0066cc);
    background: var(--bg-hover, #f0f6ff);
    color: var(--text-primary, #222);
    font-weight: 600;
}

.mlw-rail-num {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--bg-secondary, #e0e0e0);
    color: var(--text-primary, #333);
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mlw-rail-step.active .mlw-rail-num {
    background: var(--accent-color, #0066cc);
    color: #fff;
}

.mlw-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.mlw-step-panel {
    flex: 1;
    overflow: auto;
    padding: 16px 20px;
}

.mlw-nav {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 20px;
    border-top: 1px solid var(--border-color, #e0e0e0);
}

.mlw-nav-spacer { flex: 1; }

.mlw-step-title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 4px;
}

.mlw-step-help {
    font-size: 12px;
    color: var(--text-secondary, #666);
    margin-bottom: 14px;
    line-height: 1.5;
}

.mlw-placeholder {
    font-size: 13px;
    color: var(--text-secondary, #888);
    font-style: italic;
    padding: 20px 16px;
}

/* Step 1 — symptom cards */

.mlw-symptom-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 10px;
    margin-bottom: 16px;
}

.mlw-symptom-card {
    border: 1px solid var(--border-color, #ddd);
    border-radius: 6px;
    padding: 10px 12px;
    cursor: pointer;
    font-size: 12px;
    background: var(--bg-primary, #fff);
    transition: border-color 0.15s, background 0.15s;
}

.mlw-symptom-card:hover {
    border-color: var(--accent-color, #0066cc);
}

.mlw-symptom-card.mlw-selected {
    border-color: var(--accent-color, #0066cc);
    background: rgba(0, 102, 204, 0.12);
    font-weight: 600;
}

.mlw-symptom-phrase {
    display: block;
    margin-bottom: 4px;
}

.mlw-symptom-kernel {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: var(--text-secondary, #888);
}

.mlw-override-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
}

.mlw-override-row select {
    flex: 1;
    max-width: 320px;
    width: auto;
}

.mlw-clone-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid var(--border-color, #e0e0e0);
}

/* Step 4 — tuning */

.mlw-tune-layout {
    display: flex;
    gap: 24px;
}

.mlw-tune-params {
    flex: 1;
    min-width: 0;
}

.mlw-tune-projections {
    width: 260px;
    flex-shrink: 0;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 6px;
    padding: 12px;
    font-size: 12px;
    align-self: flex-start;
}

.mlw-param-row {
    margin-bottom: 14px;
}

.mlw-param-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 4px;
}

.mlw-param-note {
    font-size: 11px;
    color: var(--text-secondary, #888);
    margin-top: 3px;
    line-height: 1.4;
}

.mlw-param-error {
    font-size: 11px;
    color: #c0392b;
    margin-top: 3px;
}

.mlw-proj-row {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    border-bottom: 1px solid var(--border-color, #eee);
}

.mlw-proj-basis {
    margin-top: 8px;
    font-size: 10px;
    color: var(--text-secondary, #888);
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.mlw-validation-warnings {
    margin-top: 14px;
}

.mlw-warning-row, .mlw-error-row {
    font-size: 11px;
    padding: 4px 8px;
    border-radius: 4px;
    margin-bottom: 4px;
}

.mlw-warning-row {
    background: #fff8e1;
    color: #7a5c00;
}

.mlw-error-row {
    background: #f8d7da;
    color: #721c24;
}

/* Step 5 — preview timeline */

.mlw-preview-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.mlw-preview-layout {
    display: flex;
    gap: 24px;
}

.mlw-preview-params {
    width: 260px;
    flex-shrink: 0;
}

.mlw-preview-main {
    flex: 1;
    min-width: 0;
}

.mlw-preview-controls #mlw-preview-entity {
    min-width: 280px;
}

.mlw-range-chips {
    display: flex;
    gap: 4px;
}

.mlw-range-chip.active {
    background: var(--accent-color, #0066cc);
    color: #fff;
}

.mlw-preview-status {
    font-size: 12px;
    min-height: 16px;
    margin-bottom: 8px;
}

.mlw-preview-status.mlw-error-row {
    padding: 6px 8px;
    border-radius: 4px;
}

.mlw-timeline {
    display: flex;
    flex-direction: column;
    gap: 6px;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 6px;
    padding: 12px;
}

.mlw-timeline-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.mlw-timeline-label {
    width: 110px;
    flex-shrink: 0;
    font-size: 11px;
    color: var(--text-secondary, #666);
}

.mlw-timeline-canvas {
    flex: 1;
    width: 100%;
    height: 48px;
    background: var(--bg-secondary, #fafafa);
    border-radius: 4px;
}

.mlw-timeline-unavailable {
    flex: 1;
    font-size: 12px;
    font-style: italic;
    color: var(--text-secondary, #888);
    padding: 4px 0;
}

.mlw-timeline-track {
    position: relative;
    flex: 1;
    height: 24px;
    background: var(--bg-secondary, #fafafa);
    border-radius: 4px;
}

.mlw-evidence-track {
    height: 16px;
    background: none;
}

.mlw-tl-event, .mlw-tl-rejected {
    position: absolute;
    top: 3px;
    bottom: 3px;
    border-radius: 3px;
}

.mlw-tl-event {
    background: var(--accent-color, #0066cc);
}

.mlw-tl-rejected {
    background: repeating-linear-gradient(45deg, rgba(150,150,150,0.5), rgba(150,150,150,0.5) 3px, rgba(150,150,150,0.2) 3px, rgba(150,150,150,0.2) 6px);
    border: 1px dashed #999;
}

.mlw-tl-evidence {
    position: absolute;
    top: 3px;
    width: 8px;
    height: 8px;
    background: #e07b00;
    transform: translateX(-4px) rotate(45deg);
}

.mlw-preview-summary {
    margin-top: 10px;
    font-size: 12px;
    color: var(--text-primary, #333);
    line-height: 1.6;
}

/* Step 3 — sensor/channel picker */

.mlw-channel-layout {
    display: flex;
    gap: 24px;
}

.mlw-channel-browse {
    flex: 1;
    min-width: 0;
}

.mlw-channel-browse-controls {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}

.mlw-channel-browse-controls #mlw-channel-domain {
    width: 160px;
    flex-shrink: 0;
}

.mlw-channel-list {
    max-height: 260px;
    overflow-y: auto;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 6px;
}

.mlw-channel-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 6px 10px;
    border-bottom: 1px solid var(--border-color, #eee);
    font-size: 12px;
}

.mlw-channel-row:last-child { border-bottom: none; }

.mlw-channel-row-actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
}

.mlw-channel-toggle.active {
    background: var(--accent-color, #0066cc);
    color: #fff;
}

.mlw-derived-add {
    margin-top: 14px;
}

.mlw-derived-row {
    display: flex;
    gap: 8px;
    margin-top: 6px;
    flex-wrap: wrap;
}

.mlw-channel-chosen {
    width: 320px;
    flex-shrink: 0;
}

.mlw-channel-chosen-list {
    margin-bottom: 12px;
}

.mlw-chosen-channel {
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 6px;
    padding: 8px 10px;
    margin-bottom: 6px;
    font-size: 12px;
}

.mlw-chosen-channel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
    font-weight: 600;
}

.mlw-constraint-row {
    display: flex;
    gap: 6px;
}

.mlw-constraint-row .ps-input {
    flex: 1;
    min-width: 0;
}

.mlw-population-panel {
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 12px;
}

.mlw-eligible-headline {
    font-weight: 600;
    margin-bottom: 6px;
}

.mlw-excluded-row {
    color: var(--text-secondary, #666);
    margin-bottom: 4px;
}

.mlw-breakdown-title {
    margin-top: 8px;
    font-weight: 600;
}

/* Step 2 — entity granularity */

.mlw-granularity-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 10px;
    margin-bottom: 12px;
}

.mlw-granularity-card {
    border: 1px solid var(--border-color, #ddd);
    border-radius: 6px;
    padding: 12px;
    cursor: pointer;
    background: var(--bg-primary, #fff);
}

.mlw-granularity-card:hover {
    border-color: var(--accent-color, #0066cc);
}

.mlw-granularity-card.mlw-selected {
    border-color: var(--accent-color, #0066cc);
    background: rgba(0, 102, 204, 0.1);
    font-weight: 600;
}

.mlw-granularity-label {
    font-size: 13px;
    margin-bottom: 4px;
}

.mlw-granularity-key {
    font-size: 10px;
    color: var(--text-secondary, #888);
    font-family: monospace;
}

/* Step 6 — name and cadence */

.mlw-cadence-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 14px;
}

.mlw-cadence-card {
    border: 1px solid var(--border-color, #ddd);
    border-radius: 6px;
    padding: 10px 12px;
    cursor: pointer;
    font-size: 12px;
}

.mlw-cadence-card:hover {
    border-color: var(--accent-color, #0066cc);
}

.mlw-cadence-card.mlw-selected {
    border-color: var(--accent-color, #0066cc);
    background: rgba(0, 102, 204, 0.1);
}

.mlw-cadence-label {
    font-weight: 600;
    margin-bottom: 2px;
}

.mlw-cadence-detail {
    color: var(--text-secondary, #666);
}

.mlw-narratable-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
}

/* Step 7 — review and create */

.mlw-review-toggle {
    display: flex;
    gap: 4px;
    margin-bottom: 10px;
}

.mlw-review-toggle .btn.active {
    background: var(--accent-color, #0066cc);
    color: #fff;
}

.mlw-review-body {
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 10px;
}

.mlw-review-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 4px 0;
    border-bottom: 1px solid var(--border-color, #eee);
    font-size: 12px;
}

.mlw-review-row:last-child { border-bottom: none; }

.mlw-review-raw {
    font-size: 11px;
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
}

.mlw-review-actions {
    display: flex;
    gap: 8px;
    margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/ml-panel-shared.css"],"names":[],"mappings":"AAEA;;;;;;;8DAO8D;AAC9D;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,sCAAsC;IACtC,iCAAiC;IACjC,qDAAqD;IACrD,eAAe;AACnB;;AAEA,4BAA4B,aAAa,EAAE;;AAE3C;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,oDAAoD;IACpD,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+CAA+C;IAC/C,oCAAoC;IACpC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA,kBAAkB,OAAO,EAAE;;AAE3B;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,2BAA2B;;AAE3B;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mCAAmC;IACnC,gDAAgD;AACpD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,8CAA8C;IAC9C,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,8CAA8C;IAC9C,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,OAAO;IACP,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oJAAoJ;IACpJ,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,mCAAmC;;AAEnC;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,iBAAiB;IACjB,kDAAkD;IAClD,eAAe;AACnB;;AAEA,8BAA8B,mBAAmB,EAAE;;AAEnD;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,gCAAgC;;AAEhC;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA,+BAA+B;;AAE/B;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,kDAAkD;IAClD,eAAe;AACnB;;AAEA,6BAA6B,mBAAmB,EAAE;;AAElD;IACI,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB","sourcesContent":["@import url(\"./global.css\");\n\n/* Mounted as a child inside pipeline-sandbox's own view container (a flex\n   column) — fill it, rather than rendering our own fixed-position overlay.\n   Layout otherwise borrows from pipeline-sandbox.css (.ps-detail-header,\n   .ps-body, .btn, .ps-input, etc.) — this file adds the pieces shared by\n   ml-models.js and ml-labeling.js (the .mlw-* classes) that aren't covered\n   there. Originally the ML detector wizard's own stylesheet; the wizard was\n   removed (sandbox-refocus-view-tune.md), this file survived as the two\n   remaining consumers' shared styles — renamed accordingly. */\n:host {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.mlw-resume-banner {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 16px;\n    background: var(--warning-bg, #fff8e1);\n    color: var(--warning-fg, #7a5c00);\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n    font-size: 12px;\n}\n\n.mlw-resume-banner.hidden { display: none; }\n\n.mlw-layout {\n    flex: 1;\n    display: flex;\n    overflow: hidden;\n}\n\n.mlw-rail {\n    width: 220px;\n    flex-shrink: 0;\n    border-right: 1px solid var(--border-color, #e0e0e0);\n    padding: 12px 0;\n    overflow-y: auto;\n}\n\n.mlw-rail-step {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 10px 16px;\n    cursor: pointer;\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n    border-left: 3px solid transparent;\n}\n\n.mlw-rail-step:hover {\n    background: var(--bg-hover, #f5f5f5);\n}\n\n.mlw-rail-step.active {\n    border-left-color: var(--accent-color, #0066cc);\n    background: var(--bg-hover, #f0f6ff);\n    color: var(--text-primary, #222);\n    font-weight: 600;\n}\n\n.mlw-rail-num {\n    flex-shrink: 0;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: var(--bg-secondary, #e0e0e0);\n    color: var(--text-primary, #333);\n    font-size: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.mlw-rail-step.active .mlw-rail-num {\n    background: var(--accent-color, #0066cc);\n    color: #fff;\n}\n\n.mlw-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.mlw-step-panel {\n    flex: 1;\n    overflow: auto;\n    padding: 16px 20px;\n}\n\n.mlw-nav {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 20px;\n    border-top: 1px solid var(--border-color, #e0e0e0);\n}\n\n.mlw-nav-spacer { flex: 1; }\n\n.mlw-step-title {\n    font-size: 15px;\n    font-weight: 600;\n    margin-bottom: 4px;\n}\n\n.mlw-step-help {\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n    margin-bottom: 14px;\n    line-height: 1.5;\n}\n\n.mlw-placeholder {\n    font-size: 13px;\n    color: var(--text-secondary, #888);\n    font-style: italic;\n    padding: 20px 16px;\n}\n\n/* Step 1 — symptom cards */\n\n.mlw-symptom-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 10px;\n    margin-bottom: 16px;\n}\n\n.mlw-symptom-card {\n    border: 1px solid var(--border-color, #ddd);\n    border-radius: 6px;\n    padding: 10px 12px;\n    cursor: pointer;\n    font-size: 12px;\n    background: var(--bg-primary, #fff);\n    transition: border-color 0.15s, background 0.15s;\n}\n\n.mlw-symptom-card:hover {\n    border-color: var(--accent-color, #0066cc);\n}\n\n.mlw-symptom-card.mlw-selected {\n    border-color: var(--accent-color, #0066cc);\n    background: rgba(0, 102, 204, 0.12);\n    font-weight: 600;\n}\n\n.mlw-symptom-phrase {\n    display: block;\n    margin-bottom: 4px;\n}\n\n.mlw-symptom-kernel {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    color: var(--text-secondary, #888);\n}\n\n.mlw-override-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n}\n\n.mlw-override-row select {\n    flex: 1;\n    max-width: 320px;\n    width: auto;\n}\n\n.mlw-clone-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    margin-top: 10px;\n    padding-top: 10px;\n    border-top: 1px solid var(--border-color, #e0e0e0);\n}\n\n/* Step 4 — tuning */\n\n.mlw-tune-layout {\n    display: flex;\n    gap: 24px;\n}\n\n.mlw-tune-params {\n    flex: 1;\n    min-width: 0;\n}\n\n.mlw-tune-projections {\n    width: 260px;\n    flex-shrink: 0;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 6px;\n    padding: 12px;\n    font-size: 12px;\n    align-self: flex-start;\n}\n\n.mlw-param-row {\n    margin-bottom: 14px;\n}\n\n.mlw-param-label {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    margin-bottom: 4px;\n}\n\n.mlw-param-note {\n    font-size: 11px;\n    color: var(--text-secondary, #888);\n    margin-top: 3px;\n    line-height: 1.4;\n}\n\n.mlw-param-error {\n    font-size: 11px;\n    color: #c0392b;\n    margin-top: 3px;\n}\n\n.mlw-proj-row {\n    display: flex;\n    justify-content: space-between;\n    padding: 4px 0;\n    border-bottom: 1px solid var(--border-color, #eee);\n}\n\n.mlw-proj-basis {\n    margin-top: 8px;\n    font-size: 10px;\n    color: var(--text-secondary, #888);\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.mlw-validation-warnings {\n    margin-top: 14px;\n}\n\n.mlw-warning-row, .mlw-error-row {\n    font-size: 11px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    margin-bottom: 4px;\n}\n\n.mlw-warning-row {\n    background: #fff8e1;\n    color: #7a5c00;\n}\n\n.mlw-error-row {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n/* Step 5 — preview timeline */\n\n.mlw-preview-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 10px;\n    flex-wrap: wrap;\n}\n\n.mlw-preview-layout {\n    display: flex;\n    gap: 24px;\n}\n\n.mlw-preview-params {\n    width: 260px;\n    flex-shrink: 0;\n}\n\n.mlw-preview-main {\n    flex: 1;\n    min-width: 0;\n}\n\n.mlw-preview-controls #mlw-preview-entity {\n    min-width: 280px;\n}\n\n.mlw-range-chips {\n    display: flex;\n    gap: 4px;\n}\n\n.mlw-range-chip.active {\n    background: var(--accent-color, #0066cc);\n    color: #fff;\n}\n\n.mlw-preview-status {\n    font-size: 12px;\n    min-height: 16px;\n    margin-bottom: 8px;\n}\n\n.mlw-preview-status.mlw-error-row {\n    padding: 6px 8px;\n    border-radius: 4px;\n}\n\n.mlw-timeline {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 6px;\n    padding: 12px;\n}\n\n.mlw-timeline-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.mlw-timeline-label {\n    width: 110px;\n    flex-shrink: 0;\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n}\n\n.mlw-timeline-canvas {\n    flex: 1;\n    width: 100%;\n    height: 48px;\n    background: var(--bg-secondary, #fafafa);\n    border-radius: 4px;\n}\n\n.mlw-timeline-unavailable {\n    flex: 1;\n    font-size: 12px;\n    font-style: italic;\n    color: var(--text-secondary, #888);\n    padding: 4px 0;\n}\n\n.mlw-timeline-track {\n    position: relative;\n    flex: 1;\n    height: 24px;\n    background: var(--bg-secondary, #fafafa);\n    border-radius: 4px;\n}\n\n.mlw-evidence-track {\n    height: 16px;\n    background: none;\n}\n\n.mlw-tl-event, .mlw-tl-rejected {\n    position: absolute;\n    top: 3px;\n    bottom: 3px;\n    border-radius: 3px;\n}\n\n.mlw-tl-event {\n    background: var(--accent-color, #0066cc);\n}\n\n.mlw-tl-rejected {\n    background: repeating-linear-gradient(45deg, rgba(150,150,150,0.5), rgba(150,150,150,0.5) 3px, rgba(150,150,150,0.2) 3px, rgba(150,150,150,0.2) 6px);\n    border: 1px dashed #999;\n}\n\n.mlw-tl-evidence {\n    position: absolute;\n    top: 3px;\n    width: 8px;\n    height: 8px;\n    background: #e07b00;\n    transform: translateX(-4px) rotate(45deg);\n}\n\n.mlw-preview-summary {\n    margin-top: 10px;\n    font-size: 12px;\n    color: var(--text-primary, #333);\n    line-height: 1.6;\n}\n\n/* Step 3 — sensor/channel picker */\n\n.mlw-channel-layout {\n    display: flex;\n    gap: 24px;\n}\n\n.mlw-channel-browse {\n    flex: 1;\n    min-width: 0;\n}\n\n.mlw-channel-browse-controls {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.mlw-channel-browse-controls #mlw-channel-domain {\n    width: 160px;\n    flex-shrink: 0;\n}\n\n.mlw-channel-list {\n    max-height: 260px;\n    overflow-y: auto;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 6px;\n}\n\n.mlw-channel-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 6px 10px;\n    border-bottom: 1px solid var(--border-color, #eee);\n    font-size: 12px;\n}\n\n.mlw-channel-row:last-child { border-bottom: none; }\n\n.mlw-channel-row-actions {\n    display: flex;\n    gap: 4px;\n    flex-shrink: 0;\n}\n\n.mlw-channel-toggle.active {\n    background: var(--accent-color, #0066cc);\n    color: #fff;\n}\n\n.mlw-derived-add {\n    margin-top: 14px;\n}\n\n.mlw-derived-row {\n    display: flex;\n    gap: 8px;\n    margin-top: 6px;\n    flex-wrap: wrap;\n}\n\n.mlw-channel-chosen {\n    width: 320px;\n    flex-shrink: 0;\n}\n\n.mlw-channel-chosen-list {\n    margin-bottom: 12px;\n}\n\n.mlw-chosen-channel {\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 6px;\n    padding: 8px 10px;\n    margin-bottom: 6px;\n    font-size: 12px;\n}\n\n.mlw-chosen-channel-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 6px;\n    font-weight: 600;\n}\n\n.mlw-constraint-row {\n    display: flex;\n    gap: 6px;\n}\n\n.mlw-constraint-row .ps-input {\n    flex: 1;\n    min-width: 0;\n}\n\n.mlw-population-panel {\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 6px;\n    padding: 10px 12px;\n    font-size: 12px;\n}\n\n.mlw-eligible-headline {\n    font-weight: 600;\n    margin-bottom: 6px;\n}\n\n.mlw-excluded-row {\n    color: var(--text-secondary, #666);\n    margin-bottom: 4px;\n}\n\n.mlw-breakdown-title {\n    margin-top: 8px;\n    font-weight: 600;\n}\n\n/* Step 2 — entity granularity */\n\n.mlw-granularity-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 10px;\n    margin-bottom: 12px;\n}\n\n.mlw-granularity-card {\n    border: 1px solid var(--border-color, #ddd);\n    border-radius: 6px;\n    padding: 12px;\n    cursor: pointer;\n    background: var(--bg-primary, #fff);\n}\n\n.mlw-granularity-card:hover {\n    border-color: var(--accent-color, #0066cc);\n}\n\n.mlw-granularity-card.mlw-selected {\n    border-color: var(--accent-color, #0066cc);\n    background: rgba(0, 102, 204, 0.1);\n    font-weight: 600;\n}\n\n.mlw-granularity-label {\n    font-size: 13px;\n    margin-bottom: 4px;\n}\n\n.mlw-granularity-key {\n    font-size: 10px;\n    color: var(--text-secondary, #888);\n    font-family: monospace;\n}\n\n/* Step 6 — name and cadence */\n\n.mlw-cadence-options {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 14px;\n}\n\n.mlw-cadence-card {\n    border: 1px solid var(--border-color, #ddd);\n    border-radius: 6px;\n    padding: 10px 12px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.mlw-cadence-card:hover {\n    border-color: var(--accent-color, #0066cc);\n}\n\n.mlw-cadence-card.mlw-selected {\n    border-color: var(--accent-color, #0066cc);\n    background: rgba(0, 102, 204, 0.1);\n}\n\n.mlw-cadence-label {\n    font-weight: 600;\n    margin-bottom: 2px;\n}\n\n.mlw-cadence-detail {\n    color: var(--text-secondary, #666);\n}\n\n.mlw-narratable-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n}\n\n/* Step 7 — review and create */\n\n.mlw-review-toggle {\n    display: flex;\n    gap: 4px;\n    margin-bottom: 10px;\n}\n\n.mlw-review-toggle .btn.active {\n    background: var(--accent-color, #0066cc);\n    color: #fff;\n}\n\n.mlw-review-body {\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 6px;\n    padding: 12px;\n    margin-bottom: 10px;\n}\n\n.mlw-review-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 4px 0;\n    border-bottom: 1px solid var(--border-color, #eee);\n    font-size: 12px;\n}\n\n.mlw-review-row:last-child { border-bottom: none; }\n\n.mlw-review-raw {\n    font-size: 11px;\n    white-space: pre-wrap;\n    word-break: break-word;\n    margin: 0;\n}\n\n.mlw-review-actions {\n    display: flex;\n    gap: 8px;\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
